module.exports = __webpack_public_path__ + "static/img/linzhipin.330d725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/linzhipin.jpg
// module id = a5Xn
// module chunks = 2